import React from 'react';

export type ButtonType = 'Round' | 'Square';
export type ButtonSize = 'Small' | 'Medium' | 'Large';
export type ButtonState = 'Enabled' | 'Disabled';

interface ButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'> {
  label: string;
  variant?: ButtonType;
  size?: ButtonSize;
  state?: ButtonState;
  showIcon?: boolean;
}

const sizeClasses: Record<ButtonSize, string> = {
  Small: 'h-8 px-4 text-sm',
  Medium: 'h-10 px-6 text-base',
  Large: 'h-12 px-8 text-lg',
};

const Button: React.FC<ButtonProps> = ({
  label,
  variant = 'Round',
  size = 'Small',
  state = 'Enabled',
  showIcon = false,
  className = '',
  disabled,
  ...rest
}) => {
  const isDisabled = state === 'Disabled' || disabled;
  const shapeClass = variant === 'Round' ? 'rounded-full' : 'rounded-lg';

  return (
    <button
      type="button"
      disabled={isDisabled}
      className={[
        'inline-flex items-center justify-center font-medium transition-colors focus:outline-none',
        shapeClass,
        sizeClasses[size],
        isDisabled
          ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
          : 'bg-[#674fa3] text-white hover:bg-[#5a4490]',
        className,
      ].join(' ')}
      {...rest}
    >
      {showIcon ? null : label}
    </button>
  );
};

export default Button;
